import type { InjectionKey, Ref } from "vue";

interface DropdownMenuProvide {
  close: () => void;
  // false when the dropdown was opened by hovering: its content must not take the focus on mount
  autofocus: Readonly<Ref<boolean>>;
}

export const dropdownKey: InjectionKey<DropdownMenuProvide> = Symbol("dropdownMenu");
